import { Button, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import Donate from '../../../components/SvgIcon/icons/Donate'

export function CapacitacionAction() {
  const handleCapacitaciones = () => {
    window.open('https://amipass.com/material/landsmart/', '_blank')
  }

  return (
    <Button
      onClick={handleCapacitaciones}
      style={{
        margin: 0,
        paddingTop: 25,
        paddingBottom: 25,
        width: 'fit-content',
        boxShadow: '3px 4px 9px 0px #00000026',
      }}
    >
      <HStack>
        <Donate width="30" height="30" color="#ffffff" />
        <Text style={{ color: '#FFFFFF', textAlign: 'start' }} fontSize={14}>
          Sitio capacitación
          <br />
          colaboradores
        </Text>
      </HStack>
    </Button>
  )
}
